<div class="row">
  <div class="col-12">
    <mat-tab-group mat-align-tabs="start">
      <mat-tab label="{{'menuBar.shipment' | translate}}">
        <app-shipment-specification-list
          (dirtyEvent)="this.isDirtyCheckEvent($event)"></app-shipment-specification-list>
      </mat-tab>
      <mat-tab label="{{'menuBar.invoice' | translate}}" *ngIf="isCustomInvoice">
        <app-invoice-specification-list
          (dirtyEvent)="this.isDirtyCheckEvent($event)"></app-invoice-specification-list>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
